<!-- 视频详情 -->
<template>
  <div
    class="wrap video-box-fixed"
    :class="{ 'video-box-fixed': showVideoArr || showDesc }"
  >
    <div class="header" :style="{ top: first_open ? '1rem' : 0 }">
      <img
        src="@/assets/icon-154.png"
        class="return-img"
        @click="$router.back()"
        alt=""
      />
      <!--  -->

      <!-- <p class="header-title">视频</p> -->

      <button class="header-btn1" @click="showShareFn()">
        <img src="@/assets/icon-156.png" alt="" />
      </button>
      <button class="header-btn2" @click="showShareFn()">
        <img src="@/assets/icon-155.png" alt="" />
      </button>
    </div>

    <div
      class="video-box"
      ref="video2"
      :style="{ top: first_open ? '1rem' : 0 }"
    >
      <!-- 正常播放器 -->
      <div
        id="player-con"
        class="prism-player"
        v-if="
          aliPlayerTrue &&
          info.video_arr.length > 0 &&
          (!videoIsVip || (videoIsVip && isLogin && isVip)) &&
          !!ali_vid
        "
      ></div>
      <!-- 手机号水印 -->
      <div
        ref="position-phone"
        class="position-phone"
        v-if="
          info.video_arr.length > 0 &&
          (!videoIsVip || (videoIsVip && isLogin && isVip)) &&
          !!ali_vid
        "
      >
        <span>{{
          userInfo.phone
            ? userInfo.phone.slice(0, 3) + "****" + userInfo.phone.slice(7)
            : ""
        }}</span>
        <span>{{
          userInfo.phone
            ? userInfo.phone.slice(0, 3) + "****" + userInfo.phone.slice(7)
            : ""
        }}</span>
      </div>
    </div>

    <div
      class="video-box"
      v-if="
        !(
          aliPlayerTrue &&
          info.video_arr.length > 0 &&
          (!videoIsVip || (videoIsVip && isLogin && isVip))
        ) ||
        !aliPlayerInitEnd ||
        !!ali_vid === false
      "
    >
      <!-- 无法观看提示 -->
      <div class="no-video">
        <!-- <span v-if="!isLogin">请登录后观看</span> -->
        <div v-if="!aliPlayerTrue" style="font-size: 16px">
          当前浏览器不支持DRM播放请前往APP观看
          <br />
          <div style="font-size: 10px; margin-top: 10px">
            如未下载APP 请在应用商店下载"搞一下汽车电子"APP
          </div>

          <br />
          <button
            @click="
              $refs.openApp.openApp(
                `/video?id=${info.id}&url_id=${currentVideo.id}`
              )
            "
          >
            打开APP
          </button>
        </div>
        <span v-else-if="info.video_arr.length === 0 || !aliPlayerInitEnd"
          >正在加载视频资源...</span
        >
        <span v-else-if="aliPlayerInitEnd && !!ali_vid === false"
          >暂无视频资源</span
        >
        <span v-else-if="videoIsVip && !isVip">您还不是会员，请购买后观看</span>
      </div>
    </div>

    <!-- 正常的详情页 -->
    <div class="details-wrap" ref="headPaddingBox">
      <div class="head">
        <div class="head-avatar-row">
          <img
            :src="currentVideo.app_logo"
            alt=""
            v-if="currentVideo.app_logo"
          />
          <img src="@/assets/avatar.png" alt="" v-else />
          {{ currentVideo.app_name || "匿名用户" }}
        </div>
        <div class="head-top">
          <div class="head-top-between">
            <p class="head-name">
              <!--							{{ currentVideo.title || info.title }}-->
              <!--							<img src="@/assets/icon-151.png" class="toOpen" alt="">-->
              <text-hide-by-line
                :val="currentVideo.title || info.title"
                :max-line="1"
                btn-type="icon"
              />
            </p>
          </div>
          <div class="head-row">
            <span class="tag" v-if="videoIsVip">VIP</span>
            <span class="font-1" v-if="videoIsVip">&nbsp·&nbsp</span>
            <span class="font-1">
              {{
                (info.video_arr || []).length > 0
                  ? currentVideo.read_num || 0
                  : 0
              }}
              播放 ·
              {{ info.is_over ? "已完结" : `已更新${info.video_arr.length}集` }}
              · 共{{ info.total_sequel }}集 ·
              <span @click="showDesc = true">简介></span>
            </span>
          </div>
          <div class="head-module">
            <div
              class="head-module-head"
              :class="{ active: moreLink.length === 4 }"
              v-for="(item, index) in moreLink"
              :key="index"
              @click="item.click"
            >
              <div class="head-left">
                <img :src="item.icon" alt="" />
                <span>{{ item.title }}</span>
              </div>
              <div class="head-right">
                <span v-show="moreLink.length === 1">点击查看</span>
                <img
                  src="@/assets/icon-114.png"
                  class="head-back-icon"
                  alt=""
                  v-show="moreLink.length < 3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="selected-works">
        <div class="selected-works-between-wrap">
          <div class="selected-works-between-left">
            <span class="font-55">{{ info.title }}</span>
            <span class="font-56" @click="showVideoArr = true">· 选集</span>
            <!-- <img src="@/assets/icon-148.png" class="font-57" alt=""> -->
            <van-icon
              name="arrow"
              style="font-weight: bold"
              color="#2A63F3"
              size="16"
            />
          </div>
          <div
            class="selected-works-between-right active"
            @click="switchSet(2)"
            v-if="info.follow_switch"
          >
            <img src="@/assets/icon-113active.png" alt="" />
            已追
          </div>
          <div
            class="selected-works-between-right"
            @click="switchSet(2)"
            v-else
          >
            <img src="@/assets/icon-113.png" alt="" />
            追番
          </div>
        </div>
        <ul class="selected-works-list" ref="videoArr">
          <li
            :class="{ active: videoArrIndex === index }"
            v-for="(item, index) in info.video_arr"
            :key="index"
            @click="checkVideo(index)"
          >
            <div class="selected-works-item" ref="videoArrItem">
              <span class="selected-works-tag" v-if="item.is_vip === 1"
                >VIP</span
              >
              <p class="selected-works-row">
                <span class="font-3">{{ index + 1 }}.{{ item.title }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 视频列表的详情页 -->
    <van-popup v-model="showVideoArr" :overlay="false" position="bottom">
      <div class="video-wrap window-height">
        <div class="video-wrap-head">
          <span>选集（{{ info.video_arr.length }}）</span>
          <img
            src="@/assets/close-icon2.png"
            @click="showVideoArr = false"
            alt=""
          />
        </div>
        <ul class="selected-works-list-2">
          <li
            :class="{ active: videoArrIndex === index }"
            v-for="(item, index) in info.video_arr"
            :key="index"
            @click="checkVideo(index)"
          >
            <div class="selected-works-item2">
              <span class="selected-works-tag" v-if="item.is_vip === 1"
                >VIP</span
              >
              <p class="selected-works-row">
                <span class="font-3-2">{{ index + 1 }}.{{ item.title }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>

    <!-- 显示开通vip -->
    <!--		<van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">-->
    <!--			<div class="open-vip">-->
    <!--				<p>本视频仅支持VIP会员查看</p>-->
    <!--				<button @click="$router.push('/member')">立即开通</button>-->
    <!--				<button class="cancel-btn" @click="showOpenVip = false">取消</button>-->
    <!--			</div>-->
    <!--		</van-overlay>-->

    <!-- 视频简介的详情的详情页 -->
    <van-popup v-model="showDesc" :overlay="false" position="bottom">
      <div class="introduce-wrap window-height">
        <div class="introduce-wrap-head">
          <span>简介</span>
          <img
            src="@/assets/close-icon2.png"
            @click="showDesc = false"
            alt=""
          />
        </div>
        <p class="introduce-msg">
          {{ currentVideo.desc || info.desc || "暂无简介" }}
        </p>
      </div>
    </van-popup>

    <button
      class="full-screen-selection-btn1 is-full-screen"
      ref="fullScreenSelectionBtn1"
      @click="playNext"
    >
      <img src="../../assets/next.png" alt="" />
    </button>
    <button
      class="full-screen-selection-btn is-full-screen"
      ref="fullScreenSelectionBtn"
      @click="fullScreenSelection = true"
    >
      选集
    </button>
    <button
      class="full-screen-selection-btn no-full-screen"
      ref="fullScreenSelectionBtn2"
      @click="showVideoArr = true"
    >
      选集
    </button>

    <div class="video-header" style="display: none" ref="videoHeader">
      <text-hide-by-line
        :val="currentVideo.title || info.title"
        :max-line="1"
        :hide-btn="true"
        bg-color="rgba(0,0,0,0)"
      />
      <!--      <button class="header-btn1" @click="showShareFn()">-->
      <!--        <img src="@/assets/icon-156.png" alt="">-->
      <!--      </button>-->
      <!--      <button class="header-btn2" @click="showShareFn()">-->
      <!--        <img src="@/assets/icon-155.png" alt="">-->
      <!--      </button>-->
    </div>

    <!-- 全屏-选集 -->

    <div
      class="full-screen-selection-window"
      ref="fullScreenSelection"
      v-show="fullScreenSelection"
      @click="fullScreenSelection = false"
    >
      <p class="full-screen-selection-title">选集</p>
      <ul class="full-screen-selection-list">
        <li
          :class="{ active: videoArrIndex === index }"
          v-for="(item, index) in info.video_arr"
          :key="index"
          @click.stop="checkVideo(index, true)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>

    <!--		&lt;!&ndash; 倍速 &ndash;&gt;-->
    <!--		<van-overlay :show="doubleSpeed" @click="doubleSpeed = false" z-index="99999"-->
    <!--			style="background-color: rgba(0,0,0,.9) !important;">-->
    <!--			<div class="double-speed-window">-->
    <!--				<p class="double-speed-title">-->
    <!--					倍速-->
    <!--				</p>-->
    <!--				<ul class="double-speed-list">-->
    <!--					<li class="active">0.5X</li>-->
    <!--					<li>0.75X</li>-->
    <!--					<li>1X</li>-->
    <!--					<li>1.25X</li>-->
    <!--					<li>1.5X</li>-->
    <!--					<li>2X</li>-->
    <!--					<li>3X</li>-->
    <!--				</ul>-->
    <!--			</div>-->
    <!--		</van-overlay>-->

    <!-- 最新底部 -->
    <div class="footer">
      <div class="footer-wrap">
        <div class="footer-input-box" @click="$refs.comments.commentPostShow()">
          <input
            class="footer-input"
            disabled
            placeholder="发布一条友善的评论"
          />
        </div>
        <ul class="footer-list">
          <li @click="$refs.commentsPopup.showFn(commentsOption)">
            <img src="@/assets/icon-122.png" class="footer-icon" alt="" />
            {{ $refs.comments ? $refs.comments.totalNum : 0 }}
          </li>
          <li @click="videoTags()">
            <img
              src="@/assets/icon-123active.png"
              class="footer-icon"
              v-if="currentVideo.is_praise === 1"
              alt=""
            />
            <img
              src="@/assets/icon-123.png"
              class="footer-icon"
              v-else
              alt=""
            />
            {{ currentVideo.praise_num || 0 }}
          </li>

          <li @click="userCollect()">
            <img
              src="@/assets/icon-124active.png"
              class="footer-icon"
              v-if="currentVideo.is_collect === 1"
              alt=""
            />
            <img
              src="@/assets/icon-124.png"
              class="footer-icon"
              v-else
              alt=""
            />
            {{ currentVideo.collect_num || 0 }}
          </li>
        </ul>
      </div>
    </div>

    <!-- 评论列表 -->
    <comments
      ref="comments"
      :suckering="true"
      :get-header-height="() => $refs.headPaddingBox.offsetTop"
      :switch-val="currentVideo.switch_open"
      @switchChange="switchSet(7)"
    />
    <!-- 全部评论弹窗 -->
    <comments-popup
      ref="commentsPopup"
      :switch-val="currentVideo.switch_open"
      @switchChange="switchSet(7)"
      @append="$refs.comments.commentAppendToList($event)"
      @delComment="$refs.comments.resetList()"
      @likeComment="$refs.comments.updateLikeStatus($event.index, $event.tags)"
    />
    <!-- 分享弹窗 -->
    <share-popup
      ref="sharePopup"
      :followSwitch="currentVideo.switch_open"
      @share="share"
      @report="report"
      @follow="switchSet(7)"
    />
    <!-- 回到顶部 -->
    <to-top display-height="0" class="top-fixed" />

    <is-login-vip
      ref="isLoginVip"
      type="none"
      style-type="s2"
      z-index="99999999999"
      :no-status="true"
    />

    <is-login-vip
      ref="isLoginVip2"
      type="none"
      style-type="s2"
      z-index="99999999999"
      :no-status="true"
    />

    <open-app ref="openApp" />
  </div>
</template>

<script>
import {
  CollectService,
  GeneralService,
  UserCenterService,
  VideoDemandService,
  VideoService,
} from "@/common/service";
import { Dialog, Toast } from "vant";
import { isAppleMobileDevice, openApp } from "@/common/util";
import ToTop from "@/components/to-top.vue";
import Comments from "@/components/comments.vue";
import CommentsPopup from "@/components/comments-popup.vue";
import SharePopup from "@/components/share-popup.vue";
import { DRM_CERT_ID } from "@/common/config";
import TextHideByLine from "@/components/text-hide-by-line.vue";
import IsLoginVip from "@/components/is-login-vip.vue";
import OpenApp from "@/components/open-app.vue";
import { mapState } from "vuex";

const getPlayerOptions = (options = {}) =>
  JSON.parse(
    JSON.stringify({
      playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
      autoplay: false, //如果true,浏览器准备好时开始回放。
      muted: false, // 默认情况下将会消除任何音频。
      loop: false, // 导致视频一结束就重新开始。
      preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      language: "zh-CN",
      // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      // sources: [
      //   {
      //     type: "video/mp4",
      //     src: require("@/assets/Index/video1.mp4"), //视频url地址
      //   },
      // ],
      // poster: require("@/assets/Index/video01.png"), //你的封面地址
      notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      controlBar: {
        // DurationDisplay
        currentTimeDisplay: true,
        volumePanel: {
          inline: false,
        },
        timeDivider: false,
        durationDisplay: true,
        // remainingTimeDisplay: true,
        fullscreenToggle: true, //全屏按钮
      },
      ...options,
    })
  );
export default {
  components: {
    OpenApp,
    IsLoginVip,
    TextHideByLine,
    SharePopup,
    CommentsPopup,
    Comments,
    ToTop,
  },
  data() {
    return {
      Toast,
      // 显示选集
      showVideoArr: false,
      // 显示详情
      showDesc: false,
      // 显示开通vip
      showOpenVip: false,
      // 视频播放器参数
      playerOptions: getPlayerOptions(),
      // 视频详情
      info: {
        id: 0,
        // 选集列表
        video_arr: [],
      },
      // 当前选集
      videoArrIndex: 0,
      // 是否播放结束
      playEnd: true,
      // 是否重新append
      isAppend: true,
      // 选集id
      videoArrId: 0,

      // 视频是否是vip
      videoIsVip: false,
      // 是否登录
      isLogin: true,
      // 用户是否是vip
      isVip: false,
      // 当前登录用户
      userInfo: {},
      // 用户会员等级
      userLevel: {},

      // 当前播放的视频id
      ali_vid: "",
      aliPlayer: null,
      // 阿里播放器是否可用
      aliPlayerTrue: true,
      // 阿里播放器初始化结束
      aliPlayerInitEnd: false,

      // 是否replace跳转页面 1是
      replace: 0,

      // 全屏-选集弹窗
      fullScreenSelection: false,

      //倍速-弹窗
      doubleSpeed: false,
    };
  },
  computed: {
    ...mapState(["first_open"]),
    moreLink() {
      const list = [];
      if (this.currentVideo.ppt) {
        list.push({
          icon: require("@/assets/icon-147.png"),
          title: "查看PPT",
          click: () => {
            //   if (!this.isLogin) {
            //     return this.$refs.isLoginVip.show('PPT请登录后观看', 'login', 's2');
            //   }
            if (this.currentVideo.is_vip && !this.isVip) {
              return this.$refs.isLoginVip.show(
                "PPT仅支持VIP会员查看",
                "vip",
                "s2"
              );
            }
            this.toPPT(this.currentVideo.pdf_clear);
          },
        });
      }
      if (this.currentVideo.article_id && this.currentVideo.article_item) {
        list.push({
          icon: require("@/assets/icon-146.png"),
          title: "跳转图文",
          click: () => {
            //   if (this.currentVideo.article_jump === 0) {
            //     return this.$refs.isLoginVip.show('图文仅支持VIP会员查看', 'vip', 's2');
            //   }
            // this.$router.push(
            //   `/image-text-collection-list??id=${this.currentVideo.article_id}`
            // );

            this.$router.push(
              `/image-text-details?id=${this.currentVideo.article_id}&item_id=${this.currentVideo.article_item}`
            );
          },
        });
      }
      if (this.currentVideo.datum_id && this.currentVideo.datum_item) {
        list.push({
          icon: require("@/assets/icon-149.png"),
          title: "跳转资料",
          click: () => {
            if (this.currentVideo.datum_jump === 0) {
              return this.$refs.isLoginVip.show(
                "资料仅支持VIP会员查看",
                "vip",
                "s2"
              );
            }
            // this.$router.push(`/information-details?id=${this.currentVideo.datum_id}&url_id=${this.currentVideo.datum_item}`);
            this.$router.push(
              `/information-collection-list?id=${this.currentVideo.datum_id}`
            );
          },
        });
      }
      if (this.currentVideo.goods_id) {
        list.push({
          icon: require("@/assets/icon-149.png"),
          title: "相关产品",
          // click:  () => this.$router.push(`/supplier-details?goods_id=${this.currentVideo.goods_id}`),
          click: () =>
            this.$router.push(
              `/supplier-details?id=${this.currentVideo.goods_id}`
            ),
        });
      }
      return list;
    },

    currentVideo() {
      const videoArr = this.info.video_arr || [];
      return videoArr.length > 0 ? videoArr[this.videoArrIndex] : {};
    },

    // 评论区参数
    commentsOption() {
      return {
        // 列表api
        listApi: (params) =>
          VideoService.getVideoCommentList(
            {
              video_type: 1, // 视频类型（1 平台 2 会员)
              video_id: this.info.id, // 视频id
              url_id: this.currentVideo.id,
              ...params,
            },
            !this.videoIsVip
          ),
        // 点赞
        likeApi: (comment) =>
          VideoService.videoTags({
            type: 1,
            like_id: comment.id,
          }),
        // 发布评论
        postApi: (params) =>
          VideoService.videoComment({
            ...params,
            video_id: this.info.id, // 视频id
            url_id: this.currentVideo.id,
          }),
        // 回复评论
        postReplyApi: (params, comment) =>
          VideoService.secondCommend({
            ...params,
            id: comment.id,
          }),
        reportType: 2,
        // 删除评论
        delApi: (params) => VideoService.delComment({ id: params.id }),
      };
    },
  },
  mounted() {
    const option = this.$route.query;
    this.replace = parseInt(option.replace || 0);
    this.videoArrId = parseInt(option.videoArrId || 0);
    const id = parseInt(option.id || 0);
    if (id > 0) {
      this.info.id = id;
      this.getVideoDetail();
    }
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  },
  methods: {
    openApp,
    toPPT(ppt) {
      // location.href = `https://view.officeapps.live.com/op/view.aspx?src=${ppt}`;
      localStorage.setItem("PPT_VIEW_PARAM_URL", ppt);
      this.$router.push(`/ppt-view`);
    },
    playerReadied() {
      this.isAppend = false;
      setTimeout(() => {
        this.isAppend = true;
        setTimeout(() => {
          // 将滚动文字添加到视频播放组件
          // this.$refs.videoPlayer.player.el_.appendChild(this.$refs["position-msg"]);
          this.$refs.videoPlayer.player.el_.appendChild(
            this.$refs["position-phone"]
          );
          // 如果存在选集id则自动播放
          if (this.videoArrId > 0) {
            this.$refs.videoPlayer.player.play();
          }
        }, 10);
      }, 10);
    },
    getUserInfo() {
      const video_arr = this.info.video_arr;
      const { url, cover, ali_vid } = video_arr[this.videoArrIndex];
      this.ali_vid = ali_vid;
      UserCenterService.getUserInfo({})
        .then(({ data }) => {
          this.isLogin = true;
          this.userInfo = data.detail;
          this.userLevel = data.user_level || this.userLevel;
          if (this.userLevel && this.userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(
              this.userLevel.end_date.replace(/-/g, "/")
            ).getTime();
            this.isVip = currentTime < endTime;
          }
          if (this.info.is_release == 1) {
            this.isVip = true;
            console.log(123, this.info.is_release);
          }
          if (this.videoIsVip && !this.isVip) {
            this.$refs.isLoginVip.show("本视频仅支持VIP会员查看", "vip", "s2");
          }
          if (
            video_arr.length > 0 &&
            (!this.videoIsVip ||
              (this.videoIsVip && this.isLogin && this.isVip) ||
              this.info.is_release == 1)
          ) {
            // 初始化播放器
            setTimeout(() => this.initAliPlayer(url, cover, ali_vid), 300);
            return;
          }
          this.aliPlayerInitEnd = true;
        })
        .catch(() => {
          // this.aliPlayerInitEnd = true;
          this.isLogin = false;
          if (this.videoIsVip && !this.isVip) {
            this.$refs.isLoginVip.show("会员视频请登录后观看", "login", "s2");
          }
          // this.$refs.isLoginVip.show('请登录后观看', 'login', 's2');
          if (!this.videoIsVip) {
            // 初始化播放器
            setTimeout(() => this.initAliPlayer(url, cover, ali_vid), 300);
            return;
          }
        });
    },
    getVideoDetail() {
      return VideoService.getVideoDetail({
        id: this.info.id,
      }).then(({ data }) => {
        const video_arr = data.detail.video_arr || [];
        const videoArrIds = video_arr.map((item) => item.id);
        if (videoArrIds.indexOf(this.videoArrId) > -1) {
          this.videoArrIndex = videoArrIds.indexOf(this.videoArrId);
        }
        if (video_arr.length > 0 && !this.videoArrId) {
          video_arr.forEach((item, index) => {
            if (item.is_recently == 1) {
              this.videoArrIndex = index;
              // console.log('上次播放序号为'+index);
            }
          });
          this.playerOptions = getPlayerOptions({
            sources: video_arr[this.videoArrIndex].url,
            poster: video_arr[this.videoArrIndex].cover,
          });
        }
        this.videoIsVip = video_arr[this.videoArrIndex].is_vip == 1;

        this.info = data.detail;
        this.$nextTick(() => this.videoArrScroll(this.videoArrIndex));
        this.getUserInfo();

        // 评论区参数
        this.$refs.comments.init(this.commentsOption);
      });
    },
    pause(e) {
      console.log(e);
    },
    // 初始化阿里云播放器
    initAliPlayer(url, cover, ali_vid) {
      this.ali_vid = ali_vid;
      if (!!ali_vid === false) {
        this.aliPlayerInitEnd = true;
        return;
      }
      // 自定义组件 - 手机号
      const positionPhone = Aliplayer.Component({
        init: () => {},
        createEl: (el) => el.appendChild(this.$refs["position-phone"]),
      });
      const findChild = (el, className) =>
        [...el.children].filter(
          (item) => item.className.indexOf(className) >= 0
        );
      const fullScreenSelectionComponent = Aliplayer.Component({
        init: () => {},
        createEl: (el) => {
          const bar = findChild(el, "prism-controlbar")[0];
          bar.appendChild(this.$refs["fullScreenSelectionBtn"]);
          bar.appendChild(this.$refs["fullScreenSelectionBtn1"]);
          bar.appendChild(this.$refs["fullScreenSelectionBtn2"]);
          bar.appendChild(this.$refs["videoHeader"]);

          const rateComponents = findChild(bar, "rate-components")[0];
          findChild(rateComponents, "rate-list")[0].addEventListener(
            "click",
            function () {
              this.style.display = "none";
            }
          );

          el.appendChild(this.$refs["isLoginVip2"].$el);
          el.appendChild(this.$refs["fullScreenSelection"]);
        },
      });
      const aliplayerCreatedFn = (player) => {
        this.aliPlayerInitEnd = true;
        // 360浏览器层级问题
        player.tag.setAttribute("controls360", "no");
        player.tag.setAttribute("controlsList", "nodownload noremote footbar");

        player.tag.currentTime = 0;
        setTimeout(() => {
          player.play();
          setTimeout(() => player.pause(), 50);
        }, 50);

        // 如果存在选集id则自动播放
        if (this.videoArrId > 0) {
          player.play();
        }
        player.on("play", () => this.videoPlay());
        player.on("ended", () => (this.playEnd = true));
        // 清晰度
        player.on("sourceloaded", function (params) {
          const paramData = params.paramData;
          const desc = paramData.desc;
          const definition = paramData.definition;
          player
            .getComponent("QualityComponent")
            .setCurrentQuality(desc, definition);
        });
        player.on("error", (err) => {
          console.log("Ali_Player_ERR:", err);
          const errCodeList = [4018, 4021, 4022];
          // Toast(`播放器错误码：${err.paramData.error_code}，详细信息：${JSON.stringify(err.paramData)}`, {
          // 	duration: 3000
          // })
          if (errCodeList.includes(err.paramData.error_code)) {
            this.aliPlayerTrue = false;
          }
          // this.aliPlayerTrue = false;
        });
        // ------- 处理ios端全屏，取消全屏后不显示播放按钮问题 Start -------
        player.tag.addEventListener(
          "webkitendfullscreen",
          function () {
            videoExitedFullscreen();
          },
          false
        );

        function videoExitedFullscreen() {
          //check if an element is currently full screen
          if (
            document.fullScreenElement ||
            document.webkitIsFullScreen === true ||
            document.mozFullScreen ||
            document.msFullscreenElement
          ) {
            //do whatever here if the video is now (just became) full screen
            console.log("enter fullscreen");
          } else {
            console.log("fullscreen was closed");
            setTimeout(() => {
              player.pause(true);
              const childs = player._el.children;
              for (let i = 0; i < childs.length; i++) {
                if ([...childs[i].classList].includes("prism-big-play-btn")) {
                  childs[i].setAttribute("class", "prism-big-play-btn pause");
                  childs[i].style.display = "block";
                  break;
                }
              }
            }, 0);
            //do whatever you want on fullscreen close, like pause or mute
          }
        }

        // ------- 处理ios端全屏，取消全屏后不显示播放按钮问题 End -------
      };
      //存时间
      const saveTime = function (memoryVideo, currentTime) {
        localStorage.setItem(memoryVideo, currentTime);
      };
      //取时间，可以写成函数，也可以是固定的值
      const getTime = function (memoryVideo) {
        /* return返回的是自定义起播时间  */
        return localStorage.getItem(memoryVideo);
      };
      const aliPlayerOption = {
        id: "player-con",
        format: "m3u8",
        mediaType: "video",
        width: "100%",
        height: `${this.$refs["video2"].clientHeight}px`,
        autoplay: false,
        isLive: false,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "click",
        useH5Prism: true,
        keyShortCuts: true,
        showBarTime: 3000,
        components: [
          {
            name: "positionPhone",
            type: positionPhone,
          },
          {
            name: "RateComponent",
            type: AliPlayerComponent.RateComponent,
          },
          {
            name: "QualityComponent",
            type: AliPlayerComponent.QualityComponent,
            args: [
              function (definition, desc) {
                console.log(definition + "-----" + desc);
              },
            ],
          },
          {
            name: "fullScreenSelectionComponent",
            type: fullScreenSelectionComponent,
          },
          {
            name: "MemoryPlayComponent",
            type: AliPlayerComponent.MemoryPlayComponent,
            args: [false, getTime, saveTime], //args里的参数表示：第一个参数表示是否自动播放记忆时间，false为否，需要点击跳转到上次记忆的时间；第二和三个参数表示获取的时间和存入的时间
          },
        ],
        skinLayout: [
          {
            name: "bigPlayButton",
            align: "blabs",
            x: 30,
            y: 80,
          },
          {
            name: "H5Loading",
            align: "cc",
          },
          {
            name: "errorDisplay",
            align: "tlabs",
            x: 0,
            y: 0,
          },
          {
            name: "infoDisplay",
          },
          {
            name: "tooltip",
            align: "blabs",
            x: 0,
            y: 56,
          },
          {
            name: "thumbnail",
          },
          {
            name: "controlBar",
            align: "blabs",
            x: 0,
            y: 0,
            children: [
              {
                name: "progress",
                align: "blabs",
                x: 0,
                y: 44,
              },
              {
                name: "playButton",
                align: "tl",
                x: 15,
                y: 12,
              },
              {
                name: "timeDisplay",
                align: "tl",
                x: 10,
                y: 7,
              },
              {
                name: "fullScreenButton",
                align: "tr",
                x: 10,
                y: 12,
              },
              {
                name: "setting",
                align: "tr",
                x: 15,
                y: 12,
              },
              {
                name: "volume",
                align: "tr",
                x: 5,
                y: 10,
              },
            ],
          },
        ],
      };
      VideoDemandService.getVideoCredentials().then(({ data }) => {
        const encryptOption = {
          isDrm: true,
          //必选参数。可以通过点播控制台（路径：媒资库>音/视频）查询。示例：1e067a2831b641db90d570b6480f****。
          vid: ali_vid,
          //必选参数。可通过RAM访问控制控制台的AccessKey管理页面创建AccessKey，或者查看已有AccessKey Id的AccessKey Secret。
          accessKeyId: data.Credentials.AccessKeyId,
          //必选参数。视频播放的临时凭证。凭证需要提前生成。生成方式请参考创建角色并进行STS临时授权。
          securityToken: data.Credentials.SecurityToken,
          //必选参数。可通过RAM访问控制控制台的AccessKey管理页面创建AccessKey，或者查看已有AccessKey Id的AccessKey Secret。
          accessKeySecret: data.Credentials.AccessKeySecret,
          // 必选参数。媒体资源所在的区域。如cn-shanghai、eu-central-1, ap-southeast-1等。
          region: data.Credentials.region,
          // 仅苹果设备播放需要。用于请求苹果证书，可根据DRM加密的实现到视频点播或视频直播控制台获取。
          certId: "",
        };
        // 苹果设备添加
        if (isAppleMobileDevice()) {
          encryptOption.certId = DRM_CERT_ID;
        }
        this.aliPlayer = new Aliplayer(
          {
            ...aliPlayerOption,
            ...encryptOption,
            // source: JSON.stringify({"HD":"//player.alicdn.com/resource/player/qupai.mp4", "SD":"//player.alicdn.com/video/editor.mp4"}),
          },
          aliplayerCreatedFn
        );
      });
    },

    // 点赞
    videoTags() {
      const video = this.currentVideo;
      return VideoService.videoTags({
        type: 2,
        like_id: video.id,
      }).then(({ msg, data }) => {
        Toast(msg);
        this.$set(video, "is_praise", data.tags);
        if (!/[+.wW]/.test(video.praise_num)) {
          this.$set(
            video,
            "praise_num",
            parseInt(video.praise_num) + (video.is_praise === 1 ? 1 : -1)
          );
        }
      });
    },

    // 收藏
    userCollect() {
      const video = this.currentVideo;
      return CollectService.userCollect({
        coll_type: 1,
        coll_id: video.id,
      }).then(({ msg, data }) => {
        Toast(msg);
        this.$set(video, "is_collect", data.status);
        if (!/[+.wW]/.test(video.collect_num)) {
          this.$set(
            video,
            "collect_num",
            parseInt(video.collect_num) + (video.is_collect === 1 ? 1 : -1)
          );
        }
      });
    },

    // 播放
    videoPlay() {
      if (this.playEnd) {
        this.playEnd = false;
        const params = {
          video_type: 1, // 视频类型（1平台2会员)
          video_id: this.info.id, // 视频id
          url_id: this.currentVideo.id, // 平台类型必传
        };
        VideoService.videoPlay(params, !this.videoIsVip).then(() => {
          // console.log('获取播放id');
          if (!/[+.wW]/.test(this.currentVideo.read_num)) {
            this.currentVideo.read_num =
              parseInt(this.currentVideo.read_num) + 1;
          }
        });
      }
    },
    playNext() {
      let videoArrIndex = this.videoArrIndex;
      if (this.videoArrIndex < this.info.video_arr.length - 1) {
        this.videoArrIndex += 1;
      } else {
        this.videoArrIndex = 0;
      }
      const isLoginVip = false ? this.$refs.isLoginVip2 : this.$refs.isLoginVip;
      if (
        !this.isLogin &&
        this.info.video_arr[this.videoArrIndex].is_vip == 1
      ) {
        this.videoArrIndex = videoArrIndex;
        this.aliPlayer.fullscreenService.cancelFullScreen();
        return isLoginVip.show("VIP视频请登录后观看", "login", "s2");
      }
      if (!this.isVip && this.info.video_arr[this.videoArrIndex].is_vip == 1) {
        this.videoArrIndex = videoArrIndex;
        this.aliPlayer.fullscreenService.cancelFullScreen();

        return isLoginVip.show("本视频仅支持VIP会员查看", "vip", "s2");
      }

      const id = this.info.id;
      const videoArrId = this.info.video_arr[this.videoArrIndex].id;
      const path = `/video-details?id=${id}&videoArrId=${videoArrId}&replace=1`;
      if (this.aliPlayer) {
        this.aliPlayer.dispose();
      }

      this.$router.replace(path);
      // this.$router.go(0);
    },
    checkVideo(index, isFullScreen = false) {
      const isLoginVip = isFullScreen
        ? this.$refs.isLoginVip2
        : this.$refs.isLoginVip;
      // is_release 是否已购买
      // 	const videoIsVip = this.info.video_arr[index].is_release === 1 ? false : this.info.video_arr[index].is_vip === 1;
      // 	if (videoIsVip) {
      // 		if (!this.isLogin) {
      // return isLoginVip.show('VIP视频请登录后观看', 'login', 's2');
      // 		}
      // 		if (!this.isVip) {
      // 			return isLoginVip.show('本视频仅支持VIP会员查看', 'vip', 's2');
      // 		}
      // 	}
      if (!this.isLogin && this.info.video_arr[index].is_vip == 1) {
        return isLoginVip.show("VIP视频请登录后观看", "login", "s2");
      }
      if (!this.isVip && this.info.video_arr[index].is_vip == 1) {
        return isLoginVip.show("本视频仅支持VIP会员查看", "vip", "s2");
      }
      // videoArr
      if (this.videoArrIndex !== index) {
        const id = this.info.id;
        const videoArrId = this.info.video_arr[index].id;
        const path = `/video-details?id=${id}&videoArrId=${videoArrId}&replace=1`;
        if (this.aliPlayer) {
          this.aliPlayer.dispose();
        }

        this.$router.replace(path);
        // this.$router.go(0);
      }
    },

    videoArrScroll(index) {
      const videoArr = this.$refs.videoArr;
      const currentVideo = this.$refs.videoArrItem[index];
      const paddingLeft = parseInt(
        window.getComputedStyle(videoArr).marginLeft
      );
      videoArr.scrollLeft = currentVideo.offsetLeft - paddingLeft;
    },

    // 显示分享
    showShareFn() {
      const info = this.info;
      const video = this.currentVideo;
      let link = location.href;
      if (link.indexOf("videoArrId=") < 0) {
        link += "&videoArrId=" + video.id;
      }
      this.$refs.sharePopup.showFn({
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        title: video.title, // 分享标题
        imgUrl:
          video.cover.indexOf("http") > -1
            ? video.cover
            : `http:${video.cover}`, // 分享图标
        desc: info.desc || "", // 分享描述
      });
    },

    share() {
      const params = {
        video_type: 1, // 视频类型（1平台2会员)
        video_id: this.info.id, // 视频id
        url_id: this.currentVideo.id, // 平台类型必传
      };
      VideoService.videoTransmit(params).then(() => {
        if (!/[+.wW]/.test(this.currentVideo.transmit_num)) {
          this.currentVideo.transmit_num += 1;
        }
      });
    },

    // 举报
    report() {
      const type = 1; // 举报类型（1 视频 2 视频评论 3 会员 4 资料 5 图文）
      const report_id = this.info.id; // 举报内容的id
      this.$router.push(`/report?type=${type}&id=${report_id}`);
    },

    // 通知、订阅开关
    switchSet(type = 2) {
      GeneralService.switchSet({
        id: type === 2 ? this.info.id : this.currentVideo.id,
        type,
      }).then(({ data, msg }) => {
        if (type === 2) {
          this.$set(this.info, "follow_switch", data.status);
          const message = data.status
            ? { message: "追番成功！", icon: require("@/assets/icon-48.png") }
            : "取消追番";
          Toast(message);
        }
        if (type === 7) {
          this.$set(
            this.info.video_arr[this.videoArrIndex],
            "switch_open",
            data.status
          );
          Toast(data.status ? "开启通知" : "关闭通知");
        }
      });
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 calc(50vh - 60px + 83px);
  box-sizing: border-box;
}

.video-box-fixed {
  padding: 210px 0 calc(50vh - 60px + 83px);
}

/* 头部样式 */
.header {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  /*background: rgba(0, 0, 0, 1);*/
  z-index: 999;
}

.return-img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
  width: 20px;
}

.header-title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
}

.header-btn1 {
  position: absolute;
  right: 42px;
  top: 50%;
  transform: translate(0, -50%);
  width: 24px;
}

.header-btn1 > img {
  width: 24px;
}

.header-btn2 {
  position: absolute;
  right: 22px;
  top: 50%;
  transform: translate(0, -50%);
  width: 4px;
}

.header-btn2 > img {
  width: 4px;
}

.video-box {
  width: 100%;
  height: 210px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  position: relative;
}

.position-phone {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  pointer-events: none;
  box-sizing: border-box;
}
.position-phone span {
  font-size: 2.5vw;
  color: #ffffff;
  color: #a4a5aa;
  /*background: rgba(0, 0, 0, 0.5);*/
  border-radius: 2.5vw;
  padding: 0 2vw;
  opacity: 0.8;
  position: absolute;
}

.position-phone span:first-child {
  bottom: 20%;
  right: 20px;
}

.position-phone span:last-child {
  top: 20%;
  left: 20px;
}

.video-box-fixed .video-box {
  position: fixed;
  top: 0;
  z-index: 500;
}

.video-box .video-player-box,
.video-box .video-player-box >>> .video-js,
.video-box .video-player-box >>> video {
  width: 100%;
  height: 210px !important;
  background-color: #000000;
  padding: 0;
}

.video-box .video-player-box >>> .vjs-fullscreen video {
  width: 100%;
  height: auto !important;
  top: 50%;
  transform: translateY(-50%);
}

.video-box >>> .prism-big-play-btn {
  top: calc(50% - 32px) !important;
  left: calc(50% - 32px) !important;
}

.video-player-box >>> .vjs-big-play-button {
  top: calc(50% - 22.5px);
  left: calc(50% - 45px);
}

/* 倍速组件start */
.video-box >>> .rate-components {
  position: unset;
}

.video-box >>> .rate-list {
  width: 100vw;
  height: 210px !important;
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  padding: 120px calc((100vw - calc(210px * 0.25 + 10px) * 5) / 2) 0;
  box-sizing: border-box;
}

.video-box >>> .rate-list::before {
  content: "倍速";
  position: absolute;
  top: 90px;
  left: calc((100vw - calc(210px * 0.25 + 10px) * 5) / 2 + 5px);
  color: #ffffff;
  font-size: 15px;
}

.video-box >>> .rate-list li {
  float: right;
  background: none;
  font-size: 12px;
  width: calc(210px * 0.25);
  height: calc(210px * 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  position: relative;
  z-index: 9999999;
}

.video-box >>> .prism-fullscreen .rate-list {
  width: 100vw;
  height: 100% !important;
  padding: 60vh calc((100vw - calc(210px * 0.25 + 10px) * 5) / 2) 0;
}

.video-box >>> .prism-fullscreen .rate-list li {
  width: calc(210px * 0.25);
  height: calc(210px * 0.25);
}

.video-box >>> .prism-fullscreen .rate-list::before {
  top: calc(60vh - 40px);
  left: calc((100vw - calc(210px * 0.25 + 10px) * 5) / 2 + 5px);
}
/* 倍速组件end */

.head {
  width: 100%;
  display: flex;
  flex-direction: column;
  /* 		border-bottom: 1px solid #F3F3F3; */
  padding: 10px 0 0;
  box-sizing: border-box;
}

.head-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  box-sizing: border-box;
}

.head-name {
  width: 100%;
  color: #222222;
  font-size: 15px;
  margin-bottom: 3px;
}

.head-row {
  width: 100%;
  display: flex;
  align-items: center;
}

.tag {
  width: fit-content;
  height: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  color: #78581d;
  font-size: 10px;
  background-color: #f3d170;
  border-radius: 10px;
  margin-right: 2px;
}

.font-1 {
  color: #333333;
  font-size: 12px;
}

.selected-works {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 21px 0 14px;
}

.selected-works-list {
  /*width: 100%;*/
  white-space: nowrap;
  overflow-x: auto;
  /*padding-left: 12px;*/
  box-sizing: border-box;
  margin: 0 12px;
}

.selected-works-list > li {
  display: inline-block;
  width: 120px;
  margin-right: 8px;
  background-color: #f4f4f4;
  border-radius: 4px;
  vertical-align: middle;
}

.selected-works-list > li:last-child {
  margin-right: 12px;
}

.selected-works-list > li.active {
  background-color: #eff4ff;
}

.selected-works-list > li.active .font-3 {
  font-weight: bold;
  color: #2a63f3;
}

.selected-works-item {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 8px 6px;
  box-sizing: border-box;
  line-height: 17px;
}

.selected-works-tag {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  line-height: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 0 4px;
  background-color: #f3d170;
  color: #78581d;
  font-size: 10px;
}

.selected-works-row {
  width: 100%;
  /*height: 33px;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.font-3 {
  width: 100%;
  color: #444444;
  font-size: 12px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.font-3:last-child {
  margin-bottom: 0;
}

.details-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 简介 */
.introduce-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 17px;
  box-sizing: border-box;
}

.introduce-wrap-head {
  width: 100%;
  height: 49px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.introduce-wrap-head > span {
  color: #222222;
  font-size: 16px;
  font-weight: bold;
}

.introduce-wrap-head > img {
  width: 14px;
}

.introduce-msg {
  width: 100%;
  font-size: 14px;
  color: #222222;
  line-height: 2.5;
}

/* 视频列表 */
.video-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 12px;
  box-sizing: border-box;
}

.video-wrap-head {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3px;
  box-sizing: border-box;
}

.video-wrap-head > span {
  color: #222222;
  font-size: 16px;
  font-weight: bold;
}

.video-wrap-head > img {
  width: 14px;
}

/* 视频列表 */
.selected-works-list-2 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.selected-works-list-2 > li {
  width: calc(50% - 3.5px);
  background-color: #f4f4f4;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.selected-works-list-2 > li.active {
  background-color: #eff4ff;
}

.selected-works-item2 {
  width: 100%;
  min-height: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
}

.selected-works-tag {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  line-height: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 0 4px;
  background-color: #f3d170;
  color: #78581d;
  font-size: 10px;
}

.selected-works-row {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.font-3-2 {
  width: 100%;
  color: #222222;
  font-size: 12px;
  /*padding: 10px 0;*/
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.selected-works-list-2 > li.active .font-3-2 {
  color: #2a63f3;
}

.head-name {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 新增 */
.head-top-between {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.head-name {
  width: initial !important;
  flex: 1;
}

.window-height {
  height: calc(var(--viewport-height) - 210px);
  /*min-height: 300px;*/
  overflow: auto;
  position: relative;
}

.no-video {
  background: rgba(0, 0, 0, 0.9);
  color: #ffffff;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  text-align: center;
}

.no-video button {
  margin-top: 10px;
  padding: 5px 8px;
  border-radius: 5px;
  background-color: #2e67f3;
  font-size: 15px;
  color: #ffffff;
}

.open-vip {
  width: calc(100% - 110px);
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 42px 0 14px;
}

.open-vip p {
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  line-height: 35px;
  margin-bottom: 35px;
}

.open-vip button {
  width: 135px;
  height: 42px;
  background: #ebd793;
  border-radius: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #553d0e;
}

.open-vip button.cancel-btn {
  color: #666666;
  margin-top: 4px;
  background: initial;
  font-weight: normal;
}

.full-screen-selection-btn {
  height: 100%;
  float: right;
  color: #ffffff;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  padding: 2px 10px 0;
  box-sizing: border-box;
  display: none;
}
.full-screen-selection-btn1 {
  height: 100%;
  float: left;
  color: #ffffff;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  padding: 2px 10px 0;
  box-sizing: border-box;
  display: none;
}
.full-screen-selection-btn1 img {
  width: 16px;
  height: 16px;
}
.video-box >>> .full-screen-selection-btn.no-full-screen {
  display: flex;
}
.video-box .prism-fullscreen >>> .full-screen-selection-btn.is-full-screen {
  display: flex;
}
.video-box .prism-fullscreen >>> .full-screen-selection-btn1.is-full-screen {
  display: flex;
}
.video-box .prism-fullscreen >>> .full-screen-selection-btn.no-full-screen {
  display: none;
}

.full-screen-selection-window {
  width: 100%;
  height: 100vh;
  /*display: flex;*/
  /*flex-direction: column;*/
  padding: 71px;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

/* 视频非全屏start */
.video-box >>> .prism-controlbar {
  background: none;
}

.video-box >>> .prism-controlbar .prism-controlbar-bg {
  display: none;
}

.video-box >>> .prism-controlbar .prism-progress {
  width: calc(100% - 88px - 90px);
  height: 2px;
  left: 88px !important;
  right: 90px !important;
  bottom: 20px !important;
}

.video-box >>> .prism-controlbar .prism-progress .prism-progress-played {
  background-color: #ffffff;
  position: relative;
}
.video-box >>> .prism-controlbar .prism-progress .prism-progress-played::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  right: 0;
  top: -3px;
}

.video-box >>> .prism-controlbar .prism-play-btn {
  position: absolute;
  left: 8px;
  bottom: 10px;
  margin: 0 !important;
}

.video-box >>> .prism-controlbar .prism-time-display .current-time {
  width: 55px;
  text-align: center;
  position: absolute;
  left: 31px;
  bottom: 13px;
  height: 17px !important;
  font-size: 12px !important;
  color: #ffffff;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.video-box >>> .prism-controlbar .prism-time-display .duration {
  width: 55px;
  text-align: center;
  position: absolute;
  right: 32px;
  bottom: 13px;
  height: 17px !important;
  font-size: 12px !important;
  color: #ffffff;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.video-box >>> .prism-controlbar .prism-fullscreen-btn {
  position: absolute;
  right: 8px;
  bottom: 10px;
  margin: 0 !important;
}

.video-box >>> .prism-player .prism-tooltip,
.video-box >>> .prism-player .prism-thumbnail,
.video-box >>> .prism-controlbar .prism-setting-btn,
.video-box >>> .prism-controlbar .prism-volume,
.video-box >>> .prism-controlbar .full-screen-selection-btn,
.video-box >>> .prism-controlbar .rate-components,
.video-box >>> .prism-controlbar .quality-components,
.video-box >>> .prism-controlbar .prism-progress-cursor,
.video-box >>> .prism-controlbar .prism-time-display .time-bound {
  display: none !important;
}
.video-box >>> .prism-controlbar {
  background: linear-gradient(0deg, black, transparent) !important;
}
/* 视频非全屏end */

/* 视频全屏start */
.video-box >>> .prism-fullscreen .prism-controlbar {
  height: 100vh !important;
  background: linear-gradient(0deg, black, transparent, black) !important;
}

.video-box >>> .prism-fullscreen .prism-controlbar .prism-progress {
  width: 100%;
  height: 2px;
  left: 0 !important;
  right: 0 !important;
  bottom: 71px !important;
}

.video-box >>> .prism-fullscreen .prism-controlbar .prism-play-btn {
  position: absolute;
  left: 23px;
  bottom: 27px;
  margin: 0 !important;
}

.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .prism-time-display
  .current-time {
  width: 55px;
  text-align: center;
  position: absolute;
  left: 8px;
  bottom: 83px;
  line-height: 44px;
}

.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .prism-time-display
  .duration {
  width: 55px;
  text-align: center;
  position: absolute;
  right: 8px;
  bottom: 83px;
  color: #ffffff;
  line-height: 44px;
}

.video-box >>> .prism-fullscreen .prism-controlbar .prism-fullscreen-btn {
  position: fixed;
  top: 36px;
  left: 15px;
  margin: 0 !important;
  background: url(../../assets/back-icon7.png) no-repeat;
  background-size: 20px 20px;
}

.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .full-screen-selection-btn.is-full-screen {
  display: block !important;
  height: 21px;
  position: absolute;
  padding: 0 10px;
  right: 16px;
  bottom: 30px;
  font-size: 15px;
  color: #ffffff;
}
.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .full-screen-selection-btn1.is-full-screen {
  display: block !important;
  height: 21px;
  position: absolute;
  padding: 0 10px;
  left: 40px;
  bottom: 30px;
  font-size: 15px;
  color: #ffffff;
}
.video-box >>> .prism-fullscreen .prism-controlbar .rate-components {
  height: 21px;
  display: block !important;
  position: absolute;
  right: 144px;
  bottom: 30px;
}

.video-box >>> .prism-fullscreen .prism-controlbar .quality-components {
  height: 21px;
  border: 1px solid #ffffff;
  display: block !important;
  position: absolute;
  right: 78px;
  bottom: 30px;
}
.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .quality-components
  .quality-list {
  width: max-content !important;
  bottom: 25px;
  left: 50%;
  transform: translateX(calc(-50% + -3px));
}

.video-box
  >>> .prism-fullscreen
  .prism-controlbar
  .quality-components
  .quality-list
  li {
  width: 100%;
  min-width: max-content !important;
  text-align: center;
  margin: 0;
  padding: 0 3px;
}

.video-box >>> .prism-fullscreen .video-header {
  position: fixed;
  left: 53px;
  top: 35px;
  width: 70vw;
  height: 25px;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  display: block !important;
}
/* 视频全屏end */

.full-screen-selection-title {
  width: 100%;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 16px;
}

.full-screen-selection-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.full-screen-selection-list > li {
  flex-shrink: 0;
  width: 100%;
  height: 46px;
  line-height: 46px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 14px;
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 15px;
  color: #ffffff;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.full-screen-selection-list > li.active {
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
}

.double-speed-window {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 171px 15px 81px;
  box-sizing: border-box;
}

.double-speed-title {
  width: 100%;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 16px;
}

.double-speed-list {
  width: 100%;
  white-space: nowrap;
  overflow: auto;
}

.double-speed-list > li {
  display: inline-block;
  width: 86px;
  height: 86px;
  line-height: 86px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-right: 11px;
  text-align: center;
}

.double-speed-list > li:last-child {
  margin-right: 0;
}

.double-speed-list > li.active {
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
}

.head-avatar-row {
  width: 100%;
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 12px;
  margin-bottom: 12px;
  padding: 0 12px;
  box-sizing: border-box;
}

.head-avatar-row > img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 7px;
}

.head-module {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.head-module-head {
  flex: 1;
  height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fc;
  padding: 14px 6px 14px 10px;
  box-sizing: border-box;
  border-radius: 6px;
  margin-right: 5px;
}

.head-module-head:last-child {
  margin-right: 0;
}

.head-left {
  flex: 1;
  color: #2a63f3;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.head-left > img {
  width: 24px;
  margin-right: 4px;
}

.head-module-head.active {
  background: #f2f4fa;
}

.head-module-head.active .head-left {
  font-size: 12px;
}

.head-module-head.active .head-left > img {
  width: 14px;
  margin-right: 3px;
}

.head-left > span {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.selected-works-between-wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 19px;
  box-sizing: border-box;
}

.selected-works-between-left {
  display: flex;
  align-items: center;
}

.font-55 {
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  max-width: 210px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font-56 {
  color: #2a63f3;
  font-size: 16px;
  font-weight: bold;
  margin-left: 2px;
}

.font-57 {
  width: 6px;
  margin-left: 4px;
}

.selected-works-between-right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 28px;
  line-height: 28px;
  background: rgba(42, 99, 243, 0.1);
  color: #2a63f3;
  border-radius: 40px;
  font-size: 13px;
  font-weight: bold;
}

.selected-works-between-right > img {
  width: 14px;
  margin-right: 2px;
}

.selected-works-between-right.active {
  /* background-color: #2A63F3;
		color: #FFFFFF; */
}

.footer {
  width: 100%;
  height: 83px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 6px 0 0 12px;
  box-sizing: border-box;
}

.footer-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}

.footer-list {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 7px;
}

.footer-list > li {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #555555;
  font-size: 11px;
}

.footer-icon {
  width: 22px;
}

.footer-input-box {
  flex: 1;
  height: 38px;
  background-color: #f3f3f3;
  border-radius: 40px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.footer-input {
  font-size: 14px;
  flex: 1;
  height: 38px;
  pointer-events: none;
}

.footer-input::placeholder {
  color: #999999;
}

.toOpen {
  width: 18px;
  vertical-align: middle;
}

.top-fixed {
  bottom: 109px !important;
}
.head-right {
  display: flex;
  color: #2a63f3;
  font-size: 13px;
  align-items: center;
}
.head-back-icon {
  width: 18px;
  margin-left: 2px;
}

/*  */
/*body*/
</style>
